import { render, staticRenderFns } from "./dag-soort.vue?vue&type=template&id=27466aac&scoped=true"
import script from "./dag-soort.vue?vue&type=script&lang=js"
export * from "./dag-soort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27466aac",
  null
  
)

export default component.exports